import React, { } from 'react';
import {
  Button, Container, Grid,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';

export default function SignupConfirmation({ classes }) {
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <img src={Images.Success} alt="Inbox" className="mt-5" />
              <h3 className="mt-6 s-16">New password ready to use</h3>

              <div className="height-14 mt-1 desc center s-14">
                Your new password successfully save
                <br />
                Please sign in again first to enter.
              </div>
            </div>

            <div className="action">
              <Container sx={{ pb: 4 }}>
                <div>
                  <Button size="large" onClick={() => navigate(ROUTES.signin())} variant="contained" className="btn-contained" fullWidth>Continue</Button>
                </div>
              </Container>
            </div>

          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
